import React from 'react';
import {StyledGrid} from 'presentation/components';
import {IconButton, Stack, Typography, useTheme} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {ProviderCard} from '../ProviderCard';
import {ProviderListViewProps} from './types';
import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

const {unaccreditedProviders, card} = translations['pt-br'].privateFlow.guideFlow.favoriteDoctors;

const ProviderListView = ({
	providers,
	iconName,
	onScheduleAppointment,
	handleOpenUnaccreditedProvidersDrawer,
}: ProviderListViewProps) => {
	const {isEnabled: isFavoriteDoctorsImprovementsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_FAVORITE_DOCTORS_IMPROVEMENTS,
	);
	const {palette} = useTheme();
	const {isMobile, isLaptop, isTablet} = useMediaQueries();
	const accreditedProfessionals = providers.filter(
		professional => !professional.flDescredenciado,
	);
	const unaccreditedProfessionals = providers.filter(
		professional => professional.flDescredenciado,
	);

	return (
		<Stack
			height="100%"
			alignItems="center"
			pb={isMobile || isTablet ? 10 : 0}
			mt={4}
			mx={isLaptop ? 4 : 'auto'}>
			{accreditedProfessionals.length > 0 ? (
				<Stack width={isLaptop ? '100%' : 618} gap={2}>
					<StyledGrid.Root>
						{accreditedProfessionals.map(professional => (
							<ProviderCard
								key={`${professional.cdPrestadorFisico}-${professional.cdEspecialidade}`}
								professional={professional}
								iconName={iconName}
								primaryActionLabel={card.primaryAction}
								onScheduleAppointment={onScheduleAppointment}
							/>
						))}
					</StyledGrid.Root>
				</Stack>
			) : null}
			{unaccreditedProfessionals.length > 0 && isFavoriteDoctorsImprovementsEnabled ? (
				<Stack
					width={isLaptop ? '100%' : 618}
					gap={1}
					mt={accreditedProfessionals.length > 0 ? 3 : 0}>
					<Stack direction="row" alignItems="center">
						<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
							{unaccreditedProviders}
						</Typography>
						<IconButton
							size="small"
							onClick={handleOpenUnaccreditedProvidersDrawer}
							aria-label={unaccreditedProviders}>
							<Icon name="info-outlined" size={18} color={palette.primary.main} />
						</IconButton>
					</Stack>
					<StyledGrid.Root>
						{unaccreditedProfessionals.map(professional => (
							<ProviderCard
								key={`${professional.cdPrestadorFisico}-${professional.cdEspecialidade}`}
								professional={professional}
								iconName={iconName}
								primaryActionLabel={card.primaryAction}
								onScheduleAppointment={onScheduleAppointment}
							/>
						))}
					</StyledGrid.Root>
				</Stack>
			) : null}
		</Stack>
	);
};

export {ProviderListView};
